import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config-service';
import { Label } from '../../models/label.model';

@Injectable({
  providedIn: 'root',
})
export class LabelService {
  constructor(private http: HttpClient) { }

  configService = inject(ConfigService);

  getLabels(
    langIso: string,
    updateUserLanguageIso: boolean = true
  ): Observable<Label[]> {
    let listUrl = this.configService.readConfig().baseUrlPublicInfrastructure + '/labels';
    if (langIso) {
      listUrl += `?&LanguageIso=${langIso}`;
      if (updateUserLanguageIso == false) {
        listUrl += '&ShouldUpdateUserLanguage=false';
      }
    }
    return this.http.get<Label[]>(listUrl);
  }
}
